import { render, staticRenderFns } from "./submit_data_overview.vue?vue&type=template&id=4e91eef2&scoped=true"
import script from "./submit_data_overview.vue?vue&type=script&lang=js"
export * from "./submit_data_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e91eef2",
  null
  
)

export default component.exports